// extracted by mini-css-extract-plugin
export default {"gridClass":"viewGroups_gridClass__Jaa3l"};